<ng-template #feedback>
 <div class="notice error feedback-card" *ngIf="error() && !modal()" role="alert">
  <wiz-icon name="help"></wiz-icon><span class="feedback-message">{{ error() }}</span>
  <button type="button" class="icon-button" aria-label="Apache 오류 닫기" (click)="error.set('')"><wiz-icon name="close"></wiz-icon></button>
 </div>
 <div class="operation-result notice feedback-card" *ngIf="resultVisible() && operation() as op" role="status" aria-atomic="true" [class.error]="op['status']==='failed'" [class.success]="op['status']==='succeeded'" [class.warn]="op['status']==='canceled'" [attr.inert]="modal() ? '' : null">
  <span class="badge" [ngClass]="tone(op['status'])">{{ status(op['status']) }}</span>
  <span class="feedback-message">{{ op['message'] || 'Apache 작업을 접수했습니다.' }}</span>
  <a class="text-link feedback-action" [routerLink]="'/operations/'+op['id']">작업 기록 보기<wiz-icon name="arrow"></wiz-icon></a>
  <button type="button" class="icon-button dismiss-result" aria-label="최근 실행 결과 닫기" (click)="resultVisible.set(false)"><wiz-icon name="close"></wiz-icon></button>
 </div>
</ng-template>
<div class="summary-strip apache-summary"><span>{{ host()['message'] }}</span><code>{{ host()['sitesDirectory'] }}</code></div>
    <div class="apache-actions" *ngIf="host()['enabled']">
      <button class="button" [disabled]="busy()" (click)="action('version')">
        <wiz-icon name="check"></wiz-icon>버전 · 최신 여부 확인</button
      ><button
        class="button"
        [disabled]="busy()"
        (click)="action('configtest')"
      >
        <wiz-icon name="settings"></wiz-icon>전체 설정 검사</button
      ><button class="button" [disabled]="busy()" (click)="action('reload')">
        <wiz-icon name="save"></wiz-icon>설정 다시 적용</button
      ><button
        class="button danger"
        [disabled]="busy()"
        (click)="confirmAction('restart')"
      >
        <wiz-icon name="refresh"></wiz-icon>Apache 재시작
      </button>
    </div>
<section class="panel">
  <div class="toolbar domain-toolbar">
    <div class="toolbar-left">
      <label class="search-field"><wiz-icon name="search"></wiz-icon><input type="search" aria-label="도메인 또는 설정 파일 검색" placeholder="예: example.com, example.conf" [ngModel]="search()" (ngModelChange)="search.set($event)" /></label>
      <div class="view-switch" role="group" aria-label="Apache 설정 보기 방식">
        <button type="button" [class.active]="mode==='domain'" [attr.aria-pressed]="mode==='domain'" (click)="mode='domain'">도메인별 보기</button>
        <button type="button" [class.active]="mode==='raw'" [attr.aria-pressed]="mode==='raw'" (click)="mode='raw'">원본 파일 보기</button>
      </div>
    </div>
    <div class="toolbar-right header-actions"><button class="button small" (click)="openCreate()" [disabled]="busy() || !host()['enabled']"><wiz-icon name="plus"></wiz-icon>설정 추가</button><button class="button small" (click)="load(true)" [disabled]="loading() || busy()"><wiz-icon name="refresh"></wiz-icon>새로고침</button></div>
  </div>
    <div class="table-wrap" *ngIf="host()['enabled'] && sites.length">
      <table *ngIf="mode==='domain'">
        <thead>
          <tr>
            <th>도메인</th>
            <th>설정 파일</th>
            <th>TLS</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of filteredDomains">
            <td>
              <span class="domain-name">{{ row['domain'] || '도메인 없음' }}</span>
              <small *ngIf="!row['domain']">ServerName / ServerAlias를 확인하세요.</small>
            </td>
            <td>
              <div class="site-file" *ngFor="let site of row['sites']">
                <a href="#" class="text-link file-link" role="button" aria-haspopup="dialog" [attr.aria-disabled]="busy() || !!site['problem']" [attr.tabindex]="busy() || site['problem'] ? -1 : 0" [attr.aria-label]="site['name'] + ' · 설정 모달 열기'" data-tooltip="설정 모달 열기" (click)="$event.preventDefault(); openSite(site)" (keydown.space)="$event.preventDefault(); openSite(site)">{{ site['name'] }}<wiz-icon name="external"></wiz-icon></a>
                <small>{{ site['managed'] ? '서비스 연결 설정' : '호스트 설정' }} · {{ row['tlsSites'].includes(site) ? 'TLS' : 'HTTP / 일반' }}</small>
                <small class="file-problem" *ngIf="site['problem']">{{ site['problem'] }}</small>
              </div>
            </td>
            <td>
              <div class="tls-status"><span class="badge" [ngClass]="row['tlsTone']">{{ row['tlsLabel'] }}</span>
              <button *ngIf="row['tlsSites'].length" type="button" class="icon-button" aria-label="TLS 인증서 상세" [disabled]="busy()" [attr.data-tooltip]="row['domain'] + ' TLS 인증서·만료일 확인'" (click)="openTls(row)"><wiz-icon name="shield"></wiz-icon></button></div>
              <small *ngIf="row['tlsDetail']">{{ row['tlsDetail'] }}</small>
              <small *ngIf="row['certificate']">{{ date(row['certificate']['expiresAt']) }} 만료</small>
            </td>
            <td>
              <div class="row-actions">
                <button *ngIf="row['certificate'] || !row['tlsSites'].length" class="button small" [disabled]="busy() || !row['certificateActionEnabled']" (click)="openCertificate(row)"><wiz-icon name="lock"></wiz-icon>{{ row['certificateAction'] }}</button>
              </div>
              <small class="action-note" *ngIf="!row['certificateActionEnabled']">{{ row['certificateHint'] }}</small>
            </td>
          </tr>
        </tbody>
      </table>
      <table *ngIf="mode==='raw'">
        <thead>
          <tr>
            <th>설정 파일</th>
            <th>연결 도메인</th>
            <th>종류</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let site of filteredSites">
            <td>
              <a href="#" class="text-link file-link" role="button" aria-haspopup="dialog" [attr.aria-disabled]="busy() || !!site['problem']" [attr.tabindex]="busy() || site['problem'] ? -1 : 0" [attr.aria-label]="site['name'] + ' · 설정 모달 열기'" data-tooltip="설정 모달 열기" (click)="$event.preventDefault(); openSite(site)" (keydown.space)="$event.preventDefault(); openSite(site)">{{ site['name'] }}<wiz-icon name="external"></wiz-icon></a>
              <small>{{ site['path'] }}</small
              ><small *ngIf="site['problem']">{{ site['problem'] }}</small>
            </td>
            <td><span class="domain-name" *ngFor="let domain of site['domains']">{{ domain }}</span><span *ngIf="!site['domains']?.length">도메인 규칙 없음</span></td>
            <td>{{ site['managed'] ? '서비스 연결' : '호스트 설정' }}</td>

          </tr>
        </tbody>
      </table>
    </div>
    <p class="muted" *ngIf="sites.length && (mode==='domain' ? !filteredDomains.length : !filteredSites.length)">검색 결과가 없습니다.</p>
    <p class="muted" *ngIf="host()['enabled'] && !sites.length && !loading()">
      활성 Apache 사이트 설정이 없습니다. ‘설정 추가’로 첫 설정을 작성하세요.
    </p>
</section>

<div
  class="modal-backdrop"
  *ngIf="modal()==='editor'"
>
  <section
    class="modal apache-modal"
    (keydown.escape)="closeModal()"
    role="dialog"
    aria-modal="true"
    aria-labelledby="apache-editor-title"
  >
    <div class="modal-header">
      <div>
        <h2 id="apache-editor-title">
          {{ selected() ? fileName : 'Apache2 설정 추가' }}
        </h2>
        <p>저장 전에 configtest를 실행하며 실패하면 적용하지 않습니다.</p>
      </div>
      <button
        class="icon-button"
        (click)="closeModal()"
        aria-label="설정 편집 닫기"
      >
        <wiz-icon name="close"></wiz-icon>
      </button>
    </div>
    <div class="modal-body editor-body">
      <div class="editor-controls">
      <div class="notice error" *ngIf="error()" role="alert">{{ error() }}</div>
      <label class="field" *ngIf="!selected()"
        >설정 파일 이름<input
          [(ngModel)]="fileName"
          name="fileName"
          placeholder="docker-infra-example.conf"
          [disabled]="busy()"
      /></label>
      <button
        class="button ai-assist-toggle"
        type="button"
        aria-controls="apache-ai-assist"
        [attr.aria-expanded]="aiAssistVisible()"
        (click)="aiAssistVisible.set(!aiAssistVisible())"
        [disabled]="busy() || (!!selected() && !selected()!['editable'])"
      >
        <wiz-icon name="spark"></wiz-icon>{{ aiAssistVisible() ? 'AI 빠른 작성 보조 닫기' : 'AI 빠른 작성 보조' }}
      </button>
      <div class="ai-assist" id="apache-ai-assist" *ngIf="aiAssistVisible()">
        <label class="field"
          >AI 요청<textarea
            [(ngModel)]="aiPrompt"
            name="aiPrompt"
            rows="2"
            [disabled]="busy() || (!!selected() && !selected()!['editable'])"
            placeholder="예: example.com을 127.0.0.1:8080으로 프록시"
          ></textarea></label
        ><button
          class="button"
          type="button"
          (click)="assist()"
          [disabled]="busy() || (!!selected() && !selected()!['editable'])"
        >
          <wiz-icon name="spark"></wiz-icon>{{ busy() && agentJob() ? 'AI 작성
          중' : 'AI로 보충' }}</button
        >
      </div>
      </div>
      <wiz-code-editor
        class="apache-code-editor"
        name="content"
        [(ngModel)]="content"
        language="apache"
        [rows]="24"
        label="Apache 설정"
        [readonly]="busy() || (!!selected() && !selected()!['editable'])"
      ></wiz-code-editor>
    </div>
    <div class="modal-footer">
      <button
        class="button"
        type="button"
        (click)="closeModal()"
        [disabled]="busy()"
      >
        <wiz-icon name="close"></wiz-icon>닫기</button
      ><button
        class="button primary"
        type="button"
        (click)="saveSite()"
        [disabled]="busy() || (!!selected() && !selected()!['editable'])"
      >
        <wiz-icon name="save"></wiz-icon>검사 후 저장 · 적용
      </button>
    </div>
  </section>
</div>
<div
  class="modal-backdrop"
  *ngIf="modal()==='certificate'"
>
  <section
    class="modal compact-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="certbot-title"
  >
    <div class="modal-header">
      <div>
        <h2 id="certbot-title">Certbot 인증서 발급</h2>
        <p><strong>{{ issueDomain }}</strong>의 관리 DNS 레코드로 발급합니다.</p>
      </div>
      <button
        class="icon-button"
        (click)="closeModal()"
        aria-label="인증서 발급 닫기"
      >
        <wiz-icon name="close"></wiz-icon>
      </button>
    </div>
    <div class="modal-body">
      <label class="field"
        >인증서 알림 이메일<input
          type="email"
          [(ngModel)]="email"
          name="email"
          placeholder="admin@example.com"
      /></label>
      <p class="muted">
        도메인이 이 Apache 호스트를 가리키고 HTTP 인증 요청을 수신할 수 있어야
        합니다.
      </p>
    </div>
    <div class="modal-footer">
      <button class="button" (click)="closeModal()">
        <wiz-icon name="close"></wiz-icon>취소</button
      ><button
        class="button primary"
        (click)="issue()"
        [disabled]="!email || busy()"
      >
        <wiz-icon name="lock"></wiz-icon>발급 시작
      </button>
    </div>
  </section>
</div>
<div
  class="modal-backdrop"
  *ngIf="modal()==='confirm'"
>
  <section
    class="modal compact-modal"
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="apache-confirm-title"
  >
    <div class="modal-header">
      <div>
        <h2 id="apache-confirm-title">
          {{ pendingAction==='update' ? 'Apache 업데이트' : 'Apache 재시작' }}
        </h2>
        <p>
          {{ pendingAction==='update' ? '패키지 목록을 갱신하고 Apache 관련
          패키지만 최신 버전으로 업데이트합니다.' : '먼저 전체 구문 검사를
          통과한 경우에만 Apache를 재시작합니다.' }}
        </p>
      </div>
    </div>
    <div class="modal-body" *ngIf="pendingAction==='update'">
      <p>확인된 버전으로 Apache를 업데이트할까요?</p>
      <pre class="version-result">{{ versionResult }}</pre>
    </div>
    <div class="modal-footer">
      <button class="button" (click)="closeModal()">
        <wiz-icon name="close"></wiz-icon>취소</button
      ><button class="button danger" [disabled]="busy()" (click)="action(pendingAction)">
        <wiz-icon name="play"></wiz-icon>{{ pendingAction==='update' ? '업데이트' : '재시작' }}
      </button>
    </div>
  </section>
</div>

<div class="modal-backdrop" *ngIf="modal()==='tls'">
  <section class="modal tls-modal" role="dialog" aria-modal="true" aria-labelledby="apache-tls-title" (keydown.escape)="closeModal()">
    <div class="modal-header"><div><h2 id="apache-tls-title">TLS 인증서 상세</h2><p>{{ tlsDomain }} · 설정에 지정된 인증서 파일을 직접 조회합니다.</p></div><button class="icon-button" aria-label="TLS 인증서 상세 닫기" (click)="closeModal()"><wiz-icon name="close"></wiz-icon></button></div>
    <div class="modal-body tls-body">
      <p *ngIf="tlsLoading()" role="status">인증서 파일과 만료일을 조회하고 있습니다…</p>
      <article class="tls-file" *ngFor="let detail of tlsDetails()">
        <h3>{{ detail['name'] }}</h3><small *ngIf="detail['checkedAt']">조회: {{ fullDate(detail['checkedAt']) }}</small>
        <p class="notice warn" *ngIf="detail['message']" role="status">{{ detail['message'] }}</p>
        <p class="notice warn" *ngIf="!detail['message'] && !detail['certificates'].length">이 도메인에 해당하는 인증서 지시문을 찾지 못했습니다.</p>
        <div class="tls-certificate" *ngFor="let cert of detail['certificates']">
          <span class="badge" [ngClass]="cert['status']==='valid' ? 'success' : cert['status']==='expired' ? 'danger' : 'warning'">{{ cert['status']==='valid' ? '유효기간 내' : cert['status']==='expired' ? '만료됨' : cert['status']==='not-yet-valid' ? '유효기간 시작 전' : '조회 실패' }}</span>
          <dl class="definition-list"><div><dt>인증서 파일</dt><dd>{{ cert['path'] }}</dd></div><div *ngIf="cert['expiresAt']"><dt>만료일</dt><dd class="tls-expiry">{{ fullDate(cert['expiresAt']) }}</dd></div><div *ngIf="cert['validFrom']"><dt>시작일</dt><dd>{{ fullDate(cert['validFrom']) }}</dd></div><div *ngIf="cert['subject']"><dt>발급 대상</dt><dd>{{ cert['subject'] }}</dd></div><div *ngIf="cert['dnsNames']?.length"><dt>인증 도메인</dt><dd>{{ cert['dnsNames'].join(', ') }}</dd></div><div *ngIf="cert['issuer']"><dt>발급 기관</dt><dd>{{ cert['issuer'] }}</dd></div></dl>
          <p class="notice error" *ngIf="cert['problem']" role="alert">{{ cert['problem'] }}</p>
        </div>
      </article>
      <p class="small-note" *ngIf="!tlsLoading()">인증서 파일의 유효기간입니다. 실제 HTTPS 연결과 신뢰 체인 검증 결과는 포함하지 않습니다.</p>
    </div>
    <div class="modal-footer"><button class="button" (click)="closeModal()">닫기</button></div>
  </section>
</div>
